export default "__VITE_ASSET__aecd8693__"